// Core imports
import * as React from 'react';

// Components imports
import DateRangePicker from 'react-daterange-picker';
import Button from 'src/components/common/Button';

// Models imports
import * as moment from 'moment';

// Style and misc imports
import './DateRange.scss';
import './ComponentStyle.scss';

class DateRange extends React.Component<IDateRangeProps, IDateRangeState> {
  private calendarRef: any = null;
  private calendarComponentRef: any = null;

  constructor(props: IDateRangeProps) {
    super(props);

    this.state = {
      calendarIsOpen: false,
      datesLocalValues: null,
      calendarFixFlag: true
    };
  }

  /* 
    handleSetDates
   */
  private handleSetDates = (dates: any) => {
    this.setState({ datesLocalValues: dates });
  };

  /* 
    saveDates : Saves date range value using props actions
   */
  private saveDates = () => {
    this.props.onDatesSelected(this.state.datesLocalValues);
  };

  /* 
    handleShowCalendar : 
   */
  private handleShowCalendar = () => {
    this.state.calendarIsOpen ? this.closeCalendar() : this.openCalendar();
  };

  /* 
    openCalendar displays the date range calendar picker.
   */
  private openCalendar = () => {
    this.setState({ calendarIsOpen: true });
  };

  /* 
    closeCalendar : hides the date range calendar picker.
   */
  private closeCalendar = (shouldClear: boolean = false) => {
    shouldClear
      ? this.setState({
          calendarIsOpen: false,
          datesLocalValues: false
        })
      : this.setState({ calendarIsOpen: false });
  };

  /* 
    clearCalendar
   */
  private clearCalendar = () => {
    this.setState({ calendarFixFlag: false }, () => {
      this.setState({ datesLocalValues: null });
      this.closeCalendar();
      this.props.onClear();
    });
  };

  /* 
    getHeaders
   */
  private getHeaders = (t: any) => {
    if (this.props.dates) {
      return (
        <React.Fragment>
          <span className="header--start">
            {this.props.dates.start.format('MM/DD/YYYY')}
          </span>
          <i className="rpds-keyboard_backspace" />
          <span className="header--end">
            {this.props.dates.end.format('MM/DD/YYYY')}
          </span>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <span className="header--start">{t('dates.startDate')}</span>
          <i className="rpds-keyboard_backspace" />
          <span className="header--end">{t('dates.endDate')}</span>
        </React.Fragment>
      );
    }
  };

  private handleClickOutside = (e: any) => {
    if (this.calendarRef == null || this.calendarRef.contains == null) {
      return;
    }
    if (this.calendarRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      calendarIsOpen: false
    });
  };

  public componentDidMount = () => {
    this.setState({ datesLocalValues: this.props.dates });
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentDidUpdate = (
    prevProps: IDateRangeProps,
    prevState: IDateRangeState
  ) => {
    if (
      prevState.calendarFixFlag === true &&
      this.state.calendarFixFlag === false
    ) {
      this.setState({ datesLocalValues: null, calendarFixFlag: true });
    }
  };

  public render() {
    const { t } = this.props;
    const calendarStatus = this.state.calendarIsOpen ? 'opened' : 'closed';
    const headerText = !this.props.dates
      ? t('dates.dateRange')
      : `${this.props.dates.start.format(
          'MM/DD/YYYY'
        )}  -  ${this.props.dates.end.format('MM/DD/YYYY')}`;

    return (
      <div
        className="rp-date-range"
        ref={ref => {
          this.calendarRef = ref;
        }}
      >
        <div
          className="date-range--date-picker"
          onClick={this.handleShowCalendar}
        >
          <span>{headerText}</span>
          <i className="rpds-calendar-today" />
        </div>

        <div className={`calendar-container ${calendarStatus}`}>
          <div className="calendar-header">{this.getHeaders(t)}</div>
          <span className="selected-dates">
            {t('dates.selectedDate_plural')}
          </span>
          {this.state.calendarIsOpen && this.state.calendarFixFlag ? (
            <DateRangePicker
              ref={(ref: any) => (this.calendarComponentRef = ref)}
              className="rp-filter-bar--calendar"
              onSelect={this.handleSetDates}
              value={this.state.datesLocalValues}
              locale={'es'}
              singleDateRange={true}
              numberOfCalendars={2}
            />
          ) : (
            <React.Fragment />
          )}
          <div className="calendar--buttons">
            <Button
              buttonClass="secondary-custom-button control-calendar-button"
              height="24px"
              width="64px"
              textTransform="uppercase"
              label={t('common.clear')}
              action={() => {
                this.clearCalendar();
              }}
            />
            <Button
              buttonClass="secondary-custom-button control-calendar-button"
              height="24px"
              width="64px"
              textTransform="uppercase"
              label={t('common.cancel')}
              action={() => {
                this.closeCalendar(true);
              }}
            />
            <Button
              buttonClass="primary-custom-button control-calendar-button"
              height="24px"
              width="64px"
              textTransform="uppercase"
              label={t('common.apply')}
              action={() => {
                this.saveDates();
                this.closeCalendar();
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DateRange;

interface IDateRangeProps {
  onDatesSelected(datesRange: any): void;
  onClear(): void;
  t: any;
  dates: { start: moment.Moment; end: moment.Moment } | null;
}

interface IDateRangeState {
  calendarIsOpen: boolean;
  datesLocalValues:
    | { start: moment.Moment; end: moment.Moment }
    | null
    | boolean;
  calendarFixFlag: boolean;
}
